/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import l10n from '../../shared/strings';
import { setMasterAssets } from './helpers/entityAdapter';

const LS_KEY = 'picsio.hideDetachFromMasterProductWarning';
const strings = l10n.DETAILS.confirmDetachFromMasterProduct;

export const removeAssets = createAsyncThunk(
  'products/removeAssets',
  async ({ assetIds, product }, {
    extra: {
      sdk, Logger, utils, showErrorDialog, showDialogAsync,
    },
    getState,
  }) => {
    try {
      const ids = assetIds || getState().assets?.selectedAssetsIds;

      if (!utils.LocalStorage.get(LS_KEY)) {
        try {
          await showDialogAsync({
            title: strings.title,
            text: strings.text,
            checkbox: {
              label: strings.checkboxLabel,
              value: false,
              onChange: (value) => {
                utils.LocalStorage.set(LS_KEY, value);
              },
            },
            textBtnOk: strings.textBtnOk,
          }).promise;
        } catch (error) {
          /** User pressed "Cancel" */
          return [];
        }
      }

      await sdk.assets.detachFromProduct(product._id, ids);
      return ids;
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not remove assets from product';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error remove assets from product'), { error }, [
        'RemoveAssetsFromProductFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(
      removeAssets.pending,
      (state, { meta }) => {
        const { product } = meta.arg;
        state.items.forEach((p) => {
          if (p._id === product._id) {
            p.isBusy = true;
          }
        });
      },
    )
    .addCase(
      removeAssets.fulfilled,
      (state, { payload: ids, meta }) => {
        const { product } = meta.arg;
        state.items.forEach((p) => {
          if (p._id === product._id) {
            if (ids.length && p.assets) {
              p.assets = p.assets.filter((a) => !ids.includes(a._id));
              setMasterAssets(state, p._id, p.assets);
            }
            p.isBusy = false;
          }
        });
      },
    )
    .addCase(
      removeAssets.rejected,
      (state, { error, meta }) => {
        state.error = error;
        const { product } = meta.arg;
        state.items.forEach((p) => {
          if (p._id === product._id) {
            p.isBusy = false;
          }
        });
      },
    );
};
